module.exports = __webpack_public_path__ + "img/99.a36c9dcc.svg";